import { useCallback } from 'react'
import { parsePhoneNumberFromString } from 'libphonenumber-js'

export function usePhoneValidation({ required = true } = {}) {
  const validatePhoneNumber = useCallback(
    (value, countryCode) => {
      // Required check
      if (required && (!value || value.trim() === '')) {
        return 'Phone number is required'
      }

      if (!required && (!value || value.trim() === '')) {
        return ''
      }
      if (/^(\d)\1+$/.test(value.replace(/\D/g, ''))) {
        return 'Enter a valid phone number'
      }

      const phoneObj = parsePhoneNumberFromString(
        value,
        countryCode?.toUpperCase(),
      )

      if (!phoneObj || !phoneObj.isValid()) {
        return 'Enter a valid phone number'
      }

      return ''
    },
    [required],
  )

  return { validatePhoneNumber }
}
